
<template>
  <div class="delta-adjustment">
    <v-container>
      <v-layout justify-center pt-3>
        <div class="adjustment-title pl-3 pt-1 pb-0">{{ title }}</div>

        <v-icon
          v-show="accessory != undefined"
          class="accessory"
          @click="accessorySelected"
        >
        {{ accessory }}
        </v-icon>

        <div class="adjustment-slider">
          <v-slider
            always-dirty
            :value="sliderPos"
            :min=0
            :max="stepCount"
            v-on:input="valueDidChange"
            v-on:change="sliderDidChange"
            :disabled="disabled"
            color="grey lighten-1"
            thumb-color="blue darken-2"
          ></v-slider>
        </div>

        <div class="adjustment-value pr-3 pb-2 pt-0">
          <v-text-field
            :value="formattedValue"
            :suffix="unit"
            reverse
            single-line
            hide-details
            v-on:blur="enteredValueDidChange"
            v-on:change="enteredValueDidChange"
            :disabled="disabled"
          ></v-text-field>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Decimal from 'decimal.js'

export default {
  name: 'range-adjustment',
  data () {
    return {  
      sliderValue: this.value,
      incrementSteps: []
    }
  },

  props: {
    ident: String,
    title: String,
    value: Number,
    min: Number,
    max: Number,
    step: Number,
    unit: String,
    fixedPrecision: Number,
    accessory: String,
    disabled: Boolean
  },

  methods: {
    numberWithCommas(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    valueDidChange(v) {
      this.sliderValue = this.steps[v]
    },
    sliderDidChange() {
      this.$emit("value-changed", { ident: this.ident, val: this.sliderValue })
    },
    findClosestStepValue(v) {
      return this.incrementSteps.reduce((best, current) => {
          return (Number(current) >= Number(v) && (!best || Number(current) < Number(best)))
              ? current
              : best;
      }, undefined);
    },
    enteredValueDidChange(v) {
      this.sliderValue =  this.findClosestStepValue(Number(v) || 0)
      this.sliderDidChange()
    },
    accessorySelected() {
      this.$emit('accessory-selected', this)
    },
    initSteps() {
      let minVal = new Decimal(this.min), maxVal = new Decimal(this.max), current = minVal

      do {    
        this.incrementSteps.push(current.toFixed(this.fixedPrecision))
        current = current.plus(this.step)
      } while(current.cmp(maxVal) == -1)

      this.incrementSteps.push(current.toFixed(this.fixedPrecision))
      return this.incrementSteps
    }
  },
  
  watch: {
    value(v){
      this.sliderValue = this.findClosestStepValue(Number(v) || 0)
    }
  },

  computed: {
    steps() {
      return this.incrementSteps.length > 0 ? this.incrementSteps : this.initSteps()
    },

    formattedValue() {
      return this.sliderValue
    },
    sliderPos() {
      return this.steps.findIndex(o => o == this.sliderValue)
    },
    stepCount() {
      return this.steps.length - 1
    }
  }
}

</script>


<style scoped>

.delta-adjustment {
  font-size: 10pt;
  width: 100%;
  height: 100%;
  line-height: 1.85ch;
  text-align: center;
  top: 0;
  right: 0;
  position: relative;
}
.adjustment-title {
  text-align: left;
  font-size: 10pt;
  color:#262626;
  font-weight: 300;
  position: absolute;
  left: 0;
  top: 0;
}
.adjustment-value {
  text-align: right;
  font-size: 16pt;
  color:#4F78C4;
  font-weight: bold;
  position: absolute;
  width: 50%;
  right: 0;
  bottom: 0;
}
.adjustment-slider {
  width: 100%;
  color:red;
}
.accessory {
  position: absolute;
  right: 20px;
  top: 0px;
  color: #4F78C4;
}

@media only screen and (max-width: 768px) {
  .adjustment-value {
    width: 80%;
    font-size: 10pt;
  }
  .adjustment-title {
    font-size: 8pt;
  }
}

@media only screen and (max-height: 550px) {
  .adjustment-value {
    width: 80%;
    font-size: 10pt;
  }
  .adjustment-title {
    font-size: 8pt;
  }
}
</style>